import { render, staticRenderFns } from "./InvestorReport.vue?vue&type=template&id=0ef5c418&scoped=true"
import script from "./InvestorReport.vue?vue&type=script&lang=js"
export * from "./InvestorReport.vue?vue&type=script&lang=js"
import style0 from "./InvestorReport.vue?vue&type=style&index=0&id=0ef5c418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef5c418",
  null
  
)

export default component.exports